import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@ipreo/muni-shared';
import { GamedaySharedModule } from '../shared/shared.module';
import { AccountCellRendererComponent } from '../shared/components/renderers/account-cell.component';
import { AllOrdersComponent } from './components/all-orders/all-orders.component';
import { DropdownFloatingFilterComponent } from './components/dropdown-floating-filter/dropdown-floating-filter.component';
import { AgGridModule } from 'ag-grid-angular';
import { ProfileModule } from '../profile/profile.module';

export const agGridModule = AgGridModule;

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ProfileModule,
    ReactiveFormsModule,
    GamedaySharedModule,
    SharedModule,
    agGridModule
  ],
  declarations: [
    AllOrdersComponent,
    AccountCellRendererComponent,
    DropdownFloatingFilterComponent
  ],
  exports: [AllOrdersComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AllOrdersModule {}
